import { useEffect, useState } from 'react';

/**
 * Hook that tracks the current theme mode (light/dark) by observing
 * changes to the data-mode attribute on document.documentElement.
 *
 * @returns The current theme mode ('light' or 'dark')
 */
export const useThemeMode = (): string => {
  const [themeMode, setThemeMode] = useState<string>(document.documentElement.dataset.mode || 'light');

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const newMode = document.documentElement.dataset.mode || 'light';
      setThemeMode(newMode);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-mode'],
    });

    return () => observer.disconnect();
  }, []);

  return themeMode;
};
